import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { EntityFormGroup } from '../entities/EntityFormGroup';
import { ImportProfile } from '../entities/ImportProfile';

@Injectable()
export class TranslationService {

  constructor(private datePipe: DatePipe, private translate: TranslateService) { }

  translateErrorMessage(errorValue: string) {

    if (!errorValue || errorValue === '') {

      return 'Kein Wert angegeben';
    }

    else {

      return errorValue;
    }
  }

 styleImportFields(value: string, property: string) {
  if (property == 'entity_type') {
	this.translate.get('data_administration.entities.' + this.convertEntityType(value) + '.single').subscribe((res: string) => {
		value = res;
	});
    return value;
  } else if (property == 'updated_at') {
    var options = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit'};
    return new Date(value).toLocaleString('de-DE', options);
  } else if (property == 'duration') {
	var parts = (value + '').split('.', 2);

    if (parts.length >= 1) {

	  var seconds = Number(parts[0]);
	  var fraction: string = null;
	  if (parts.length == 2) fraction = parts[1].slice(0,2);

      if (seconds < 60) {
		  if (fraction !== null) return seconds + ',' + fraction + ' s';
		  return seconds;
	  }
      else if (seconds < 3600) {
		  var mainPart = Math.floor((seconds / 60));
		  var secondPart = '';
		  if ((seconds % 60) < 10) secondPart = '0' + seconds % 60;
		  else secondPart = seconds % 60 + '';
		  return mainPart + ':' + secondPart + ' min';
	  }
      else {

		var minutes = Math.floor(seconds / 60);
		var mainPart = Math.floor((minutes / 60));
		var secondPart = '';
		console
		if ((minutes % 60) < 10) secondPart = '0' + minutes % 60;
		else secondPart = minutes % 60 + '';
        return mainPart + ':' + secondPart + ' h';
      }
    } else {

      return 'keine Zeit erfasst';
    }
  } else if (property == 'author') {
    if (value['first_name'] && value['last_name']) return value['first_name'] + ' ' + value['last_name'];
    else return 'Keine Angabe';
  } else {

    return value;
  }
}

convertToSnakeCase(camelCase: string) {
	return camelCase.split(/(?=[A-Z])/).join('_').toLowerCase();
}

styleFormLabel(formGroup: EntityFormGroup, entityType: string, correction: boolean) {

  var fieldName = formGroup['snake_case'];
  var required = formGroup['not_null'];
  var labelText = '';
  this.translate.get('data_administration.entities.' + this.convertEntityType(entityType) + '.properties.' + fieldName).subscribe((res: string) => {
	labelText = res;
	if (required) labelText += '*';
	if (correction === true && formGroup['data_type'] == 'select' && formGroup['default_value']) {
		labelText += ' (';
		this.translate.get('import.old_imported_value').subscribe((res: string) => {
			labelText += res + ': ' + formGroup['default_value'] + ')';
		});
	}
  });

  return '<label class="col-form-label">' + labelText + '</label>';
}

showResultingUrl(importProfile: ImportProfile, mode: string) {
  var queryString = '';

  importProfile.query_params.filter(queryParam => queryParam.type != 'array').forEach(item => {

    if (item.param) {
      if (item.type == 'static') {

        if (item.value && item.value != '') {
          queryString += '&' + item.param + '=' + item.value;
        }

      } else if (item.type == 'now') {
        var now = new Date();
        queryString += '&' + item.param + '=' + this.datePipe.transform(now, 'yyyy-MM-dd');
      }
    }
  });

  queryString = queryString.replace('&', '');

  if (!importProfile || importProfile.url == '') return '<code></code>';

  var array_query_params = importProfile.query_params.filter(queryParam => queryParam.type == 'array');

  if (mode == 'create') {

    if (array_query_params.length == 1 && array_query_params[0].param && array_query_params[0].array_value.length > 0) {
      let arrayString = '';
      var index = 1;

      array_query_params[0].array_value.forEach(array_value => {
        if (queryString != '') arrayString += '<br><code>' + index + '. GET ' + importProfile.url + '?' + queryString + '&' + array_query_params[0].param + '=' + array_value.value + '</code>';
        else arrayString += '<br><code>' + index + '. GET ' + importProfile.url + '?' + array_query_params[0].param + '=' + array_value.value + '</code>';

        index++;
      });

      return arrayString;
    } else {
      if (queryString != '') return '<code>GET ' + importProfile.url + '?' + queryString + '</code>';
      else return '<code>GET ' + importProfile.url + '</code>';
    }
  } else {
     if (array_query_params.length == 1 && array_query_params[0].param && array_query_params[0].value.length > 0) {

      let arrayString = '';
      var index = 1;

      array_query_params[0].value.split(',').forEach(arrayValue => {

        if (queryString != '') {

          arrayString += '<br><code>' + index + '. GET ' + importProfile.url + '?' + queryString + '&' + array_query_params[0].param + '=' + arrayValue + '</code>';
        } else {

          arrayString += '<br><code>' + index + '. GET ' + importProfile.url + '?' + array_query_params[0].param + '=' + arrayValue + '</code>';
        }

        index++;
      });

      return arrayString;
    } else {

      if (queryString != '') {
        return '<code>GET ' + importProfile.url + '?' + queryString + '</code>';
      } else {
        return '<code>GET ' + importProfile.url + '</code>';
      }
    }
   }
  }

	convertEntityType(entityType) {
		var entityTypeParts = entityType.split('\\');
		entityType = entityTypeParts[entityTypeParts.length - 1];
		return entityType.charAt(0).toLowerCase() + entityType.slice(1);
	}

	convertToPlural(entityType) {
		entityType = entityType.toLowerCase();
		switch (entityType.slice(-1)) {
			case 's': return entityType;
			case 'y': return entityType.slice(0, -1) + 'ies';
			default: return entityType + 's';
		}
	}
}
